import Log from './Log'
Log.prefix = 'Tracker';
import Bridge from '@wifikey/wkb'

/**
 * 打点（包含客户端打点）
 */
var defaultURL = 'https://wifiapi02.51y5.net/wifiapi/rd.do',
    defaultParams = {

    },
    getParams = function(o) {
        // 读缓存
        if (!!defaultParams.u) return defaultParams;
        o = o || {};
        var data = {
            'a': o.appid || '',
            'v': o.vcode || '',
            'c': o.chanid || '',
            'd': o.dhid || '',
            'u': o.uhid || '',
            'ssid': o.ssid || '',
            'bssid': o.bssid || ''
        };
        defaultParams = data;
        return data;
    },
    getDefaultParams = function(callback) {
        // 缓存处理
        if (Bridge.isWKBrowser && !defaultParams.u) {
            Bridge.call('getAppInfo', {
                success: function(o) {
                    var data = getParams(o);
                    if (callback) callback(data);
                }
            });
        } else {
            var data = getParams();
            if (callback) callback(data);
        }
    },
    splice = function(url, data) {
        var str = '';
        for (var k in data) {
            str += k + '=' + encodeURIComponent(data[k]) + '&';
        }
        if (str) {
            str += '_t=' + (+new Date());
            str = url.indexOf('?') > -1 ? '&' + str : str = '?' + str;
        }
        return url + str;
    },
    getURL = function(cfg) {
        cfg = cfg || {};
        var url = cfg.url || defaultURL;
        // 异步获取参数
        getDefaultParams(function(data) {
            for (var i in cfg.data) {
                data[i] = cfg.data[i];
            }
            // 拼接url
            var _url = splice(url, data);
            if (cfg.callback) cfg.callback(_url, cfg);
        });
    },
    request = function(url, cfg) {
        if (cfg.data.rurl) {
            location.href = url;
        } else {
            var img = new Image(),
                trackerId = "trackerId_" + (+new Date()) + '.r' + Math.floor(Math.random() * 1000);
            window[trackerId] = img;
            img.onload = img.onerror = img.onabort = function() {
                img.onload = img.onerror = img.onabort = null;
                img = window[trackerId] = null;
                if (cfg.callback) cfg.callback();
            };
            img.src = url;
        }
    },
    appTrace = function(val){ // 客户端打点
        // var value = {
        //     a: 1
        // }
        console.log('客户端打点', val)
        var cmd
        if (Bridge.isWKBrowser === 'android') {
          let _data = val.data
          
          if (typeof _data === 'object') {
            _data = JSON.stringify(_data)
          }

            cmd = '__jsi:' + JSON.stringify({
                service: 'wifikey',
                method: 'traceV2',
                param: JSON.stringify({
                    type: val.type,
                    data: _data
                })
            })
            window.console.log('call native>', cmd)
            window.prompt(cmd)
        }
        if (Bridge.isWKBrowser === 'ios') {
            // cmd = 'eventTrack ' + JSON.stringify({
            //     funId: key,
            //     desc: value
            // })
            // window.console.log('call native>', cmd)
            Bridge.call('eventTrack', {
                funId: val.type,
                desc: val.data
            })
        }
    },
    init = function() {
        Log('init');
        getDefaultParams();
    };
init();
var _obj = {
    /**
     * send
     * @param {object} cfg
     * @param {string} cfg.url - 改变打点接口
     * @param {object} cfg.data
     * @param {string} cfg.data.rurl - 打点后跳转
     * @param {string} cfg.data.f
     * @param {string} cfg.data.b
     * @param {function} cfg.callback - 回调
     */
    send: function(cfg) {
        cfg = cfg || {};
        if (!cfg.data) return;

        // 格式化
        cfg.data.f = ((this.namespace ? this.namespace + '_' : '') + cfg.data.f).replace(/-/g, '_');
        cfg.data.b = ('' + cfg.data.b).replace(/-/g, '_');

        // 客户端打点
        // if (Bridge.isWKBrowser) {
        //     Bridge.call('trace', {
        //         type: cfg.data.f,
        //         data: cfg.data.b
        //     });
        // }

        // 客户端打点
        appTrace(cfg.data);

        // 先获取拼接的url，再回调发出请求
        // getURL({
        //     url: cfg.url,
        //     data: cfg.data,
        //     callback: function(url) {
        //         request(url, cfg);
        //     }
        // });
    },
    getURL: getURL,
    namespace: process.env.tracker_namespace || ''
};

export default _obj;


// WEBPACK FOOTER //
// ./src/lib/Utils/Tracker.js